const mailTemplateTypes = [
  { id: 'FREE_FORM', name: 'Free Form' },
  { id: 'INVITATION', name: 'Invitation' },
  { id: 'CAPITAL_CALLS', name: 'Capital Calls' },
  { id: 'SEND_NEW_PASSWORD', name: 'Send New Password' },
  { id: 'REQUEST_PASSWORD', name: 'Request Password' },
  { id: 'FUND_RAISING', name: 'Fund Raising' },
  { id: 'NEWLY_UPLOADED_DOCUMENT', name: 'Newly Uploaded Document' },
  { id: 'SURVEY', name: 'Survey' }
];

const documentDateVariable = {
  label: 'Document Date',
  value: '!docdate',
  values: [
    { label: 'docdate(M.d.yyyy)', value: '!docdate(M.d.yyyy)' },
    { label: 'docdate(MM/dd/yyyy)', value: '!docdate(MM/dd/yyyy)' },
    { label: 'docdate(MM/dd/yy)', value: '!docdate(MM/dd/yy)' },
    { label: 'docdate(dd/MM/yyyy)', value: '!docdate(dd/MM/yyyy)' },
    { label: 'docdate(yyyy-MM-dd)', value: '!docdate(yyyy-MM-dd)' },
    { label: 'docdate(MM-dd-yy)', value: '!docdate(MM-dd-yy)' },
    { label: 'docdate(dd-MM-yy)', value: '!docdate(dd-MM-yy)' },
    { label: 'docdate(MM-dd-yyyy)', value: '!docdate(MM-dd-yyyy)' },
    { label: 'docdate(yyyy/MM/dd)', value: '!docdate(yyyy/MM/dd)' },
    { label: 'docdate(yyyy/dd/MM)', value: '!docdate(yyyy/dd/MM)' },
    { label: 'docdate(yyyy-dd-MM)', value: '!docdate(yyyy-dd-MM)' },
    { label: 'docdate(MMMM-d-yyyy)', value: '!docdate(MMMM-d-yyyy)' },
    { label: 'docdate(MMMM d,yyyy)', value: '!docdate(MMMM d,yyyy)' },
    { label: 'docdate(MMMM d, yyyy)', value: '!docdate(MMMM d, yyyy)' },
    { label: 'docdate(MMMM/d/yyyy)', value: '!docdate(MMMM/d/yyyy)' },
    { label: 'docdate(MM d,yyyy)', value: '!docdate(MM d,yyyy)' },
    { label: 'docdate(MM d, yyyy)', value: '!docdate(MM d, yyyy)' },
    { label: 'docdate(MM.dd.yy)', value: '!docdate(MM.dd.yy)' },
    { label: 'docdate(MM dd,yyyy)', value: '!docdate(MM dd,yyyy)' },
    { label: 'docdate(MM dd, yyyy)', value: '!docdate(MM dd, yyyy)' },
    { label: 'docdate(MM/dd/yyyy)', value: '!docdate(MM/dd/yyyy)' },
    { label: 'docdate(dd MMMM YYYY)', value: '!docdate(dd MMMM YYYY)' }
  ]
};

const dueDateVariable = {
  label: 'Due Date',
  value: '!duedate',
  values: [
    { label: 'duedate(M.d.yyyy)', value: '!duedate(M.d.yyyy)' },
    { label: 'duedate(MM/dd/yyyy)', value: '!duedate(MM/dd/yyyy)' },
    { label: 'duedate(MM/dd/yy)', value: '!duedate(MM/dd/yy)' },
    { label: 'duedate(dd/MM/yyyy)', value: '!duedate(dd/MM/yyyy)' },
    { label: 'duedate(yyyy-MM-dd)', value: '!duedate(yyyy-MM-dd)' },
    { label: 'duedate(MM-dd-yy)', value: '!duedate(MM-dd-yy)' },
    { label: 'duedate(dd-MM-yy)', value: '!duedate(dd-MM-yy)' },
    { label: 'duedate(MM-dd-yyyy)', value: '!duedate(MM-dd-yyyy)' },
    { label: 'duedate(yyyy/MM/dd)', value: '!duedate(yyyy/MM/dd)' },
    { label: 'duedate(yyyy/dd/MM)', value: '!duedate(yyyy/dd/MM)' },
    { label: 'duedate(yyyy-dd-MM)', value: '!duedate(yyyy-dd-MM)' },
    { label: 'duedate(MMMM-d-yyyy)', value: '!duedate(MMMM-d-yyyy)' },
    { label: 'duedate(MMMM d,yyyy)', value: '!duedate(MMMM d,yyyy)' },
    { label: 'duedate(MMMM d, yyyy)', value: '!duedate(MMMM d, yyyy)' },
    { label: 'duedate(MMMM/d/yyyy)', value: '!duedate(MMMM/d/yyyy)' },
    { label: 'duedate(MM d,yyyy)', value: '!duedate(MM d,yyyy)' },
    { label: 'duedate(MM d, yyyy)', value: '!duedate(MM d, yyyy)' },
    { label: 'duedate(MM.dd.yy)', value: '!duedate(MM.dd.yy)' },
    { label: 'duedate(MM dd,yyyy)', value: '!duedate(MM dd,yyyy)' },
    { label: 'duedate(MM dd, yyyy)', value: '!duedate(MM dd, yyyy)' },
    { label: 'duedate(MM/dd/yyyy)', value: '!duedate(MM/dd/yyyy)' },
    { label: 'duedate(dd MMMM YYYY)', value: '!duedate(dd MMMM YYYY)' }
  ]
};

const deliveryTabBodyVariables = [
  { label: 'Category Name', value: '!categoryName' },
  { label: 'Subcategory Name', value: '!subCategoryName' },
  documentDateVariable,
  dueDateVariable,
  { label: 'Document Title', value: '!documentTitle' },
  { label: 'Document Url', value: '!documentUrl' },
  { label: 'Encoded Document Url', value: '!encodedDocumentUrl' },
  { label: 'Email', value: '!email' },
  { label: 'Fund Name', value: '!fundName' },
  { label: 'Fund Family Name', value: '!fundFamilyName' },
  { label: 'Investor Name', value: '!investorname' },
  { label: 'User ID', value: '!UserID' },
  { label: 'First Name', value: '!firstName' },
  { label: 'Last Name', value: '!lastName' },
  { label: 'Client Name', value: '!clientName' },
  { label: 'Client DB Name', value: '!clientDBName' }
];

const deliveryTabSubjectVariables = [
  { label: 'Category Name', value: '!categoryName' },
  { label: 'Subcategory Name', value: '!subCategoryName' },
  documentDateVariable,
  dueDateVariable,
  { label: 'Document Title', value: '!documentTitle' },
  { label: 'Fund Name', value: '!fundName' },
  { label: 'Fund Family Name', value: '!fundFamilyName' },
  { label: 'Investor Name', value: '!investorname' },
  { label: 'Client Name', value: '!clientName' },
  { label: 'Client DB Name', value: '!clientDBName' }
];

const contactVariables = [
  { label: 'User Id', value: '!userId' },
  { label: 'Password', value: '!Password' },
  { label: 'User Email', value: '!userEmail' },
  { label: 'First Name', value: '!firstName' },
  { label: 'Last Name', value: '!lastName' },
  { label: 'Salutation', value: '!salutation' },
  { label: 'Client Name', value: '!clientName' },
  { label: 'Client DB Name', value: '!clientDBName' }
];

const documentUrlVariable = [
  { label: 'Document Url', value: '!documentUrl' },
  { label: 'Encoded Document Url', value: '!encodedDocumentUrl' }
];

const variablesForDistributionList = [
  documentDateVariable,
  dueDateVariable,
  { label: 'Document Title', value: '!documentTitle' },
  { label: 'Fund Name', value: '!fundname' },
  { label: 'Fund Id', value: '!fundid' },
  { label: 'Fund Family Name', value: '!fundFamilyName' },
  { label: 'Investor Name', value: '!investorname' },
  { label: 'Category Name', value: '!categoryName' },
  { label: 'Subcategory Name', value: '!subCategoryName' },
  { label: 'User Id', value: '!userId' },
  { label: 'Password', value: '!Password' },
  { label: 'First Name', value: '!firstName' },
  { label: 'Last Name', value: '!lastName' },
  { label: 'Salutation', value: '!salutation' },
  { label: 'Client Name', value: '!clientName' },
  { label: 'Client DB Name', value: '!clientDBName' },
  { label: 'User Email', value: '!userEmail' }
];

const distributionListSubjectVariables = variablesForDistributionList;

const distributionListBodyVariables = documentUrlVariable.concat(
  variablesForDistributionList
);

const mupVariables = [
  { label: 'MUP User Id', value: '!MUPUserID' },
  { label: 'MUP Password', value: '!MUPPassword' },
  { label: 'MUP First Name', value: '!MUPFirstname' },
  { label: 'MUP Lastname', value: '!MUPLastname' },
  { label: 'MUP Email', value: '!MUPEmail' }
];

export {
  mailTemplateTypes,
  deliveryTabBodyVariables,
  deliveryTabSubjectVariables,
  distributionListSubjectVariables,
  distributionListBodyVariables,
  contactVariables,
  mupVariables
};
